import FEGORender from '@futuweb/fego-render';
import FEGOEditor from '@futuweb/fego-editor';

const PAGE_TYPE_ENUM = {
    H5: 1,
    PC: 10,
}

export function isH5() {
    let route = null;
    if (FEGORender) {
        const {
            store
        } = FEGORender;
        route = store.route;
    } else {
        const {
            app: {
                project
            }
        } = FEGOEditor
        route = project.route;
    }

    return route.now.pageType === PAGE_TYPE_ENUM.H5;
}

/**
 * 将query字符串转为对象
 * @param  {string} str query字符串
 * @return {object}     query键值对对象
 */
export function query2obj(str) {
    if (str === undefined) {
        // 默认从当前域名获取
        str = location.search;
    }
    if (str.charAt(0) === '?') {
        str = str.slice(1);
    }
    if (!str) {
        return {};
    }
    const obj = {};
    const segments = str.split('&');
    for (let i = 0, l = segments.length; i < l; i++) {
        const kv = segments[i].split('=');
        const key = decodeURIComponent(kv[0]);
        const val = decodeURIComponent(kv[1]);
        obj[key] = val;
    }
    return obj;
}